<template>
  <header class="header"> 
    <div class="container grid grid-cols-3  items-center">
      <div class="text-left">
        <a href="https://www.fundacionapoyo.com">
        <img src="https://fundacionapoyo.com/wp-content/uploads/2022/03/logo-fundacion.svg" alt="https://wwww.fundacionapoyo.com">
        </a>
      </div>
      <div class="col-span-2">
      </div>
    </div>
  </header>
</template>
<script>
export default {
  name: 'HeaderComponent',
  props: { }
}
</script>
<style>
  .text-left {
    text-align: left;
  }
</style>